import plans from "./plans.component";
import plansUrls from "./plans.urls";
import PlansTransforms from "./plans.transforms";

const plansModule = angular
  .module("app.components.plans", [])
  .component("plansPage", plans)
  .service("PlansTransforms", PlansTransforms)
  .config(plansUrls);

export default plansModule;



// WEBPACK FOOTER //
// ./src/pages/plans/plans.module.js